<template>
  <div class="d-flex justify-content-end align-items-center">
    <el-button
        @click="isImport = true"
        type="primary"
        style="background: #472F92; border: none; color: white"
        class="btn btn-xs"
    >
      <i class="el-icon-star-off"></i> Import chỉ số teamlead
    </el-button>
    <el-dialog
        class="responsive" width="40%"
        v-if="isImport" :visible.sync="isImport" :show-close="false"
        append-to-body :title="title" @close="closeDialog"
    >
      <hr style="margin-top: -20px; border: 1px solid lightgray; margin-bottom: 20px"/>
      <DialogImportIndexTeamLead
          @closeDialog="closeDialog"
          @getListManageIndexTeamLead="getListManageIndexTeamLead"
          @setTitleError="setTitleDialogError"
      />
    </el-dialog>
  </div>
</template>

<script>
import DialogImportIndexTeamLead from "@/view/pages/manage-team-lead-index/component/DialogImportIndexTeamLead.vue";

export default {
  name: 'HeaderManageIndexTeamLead',
  components: { DialogImportIndexTeamLead },
  data() {
    return {
      isCreate: false,
      isImport: false,
      title: "Import chỉ số team lead",
    }
  },
  methods: {
    getListManageIndexTeamLead() {
      this.$emit('getListManageIndexTeamLead')
    },
    setTitleDialogError(value) {
      this.title = value
    },
    closeDialog() {
      this.listErrors = []
      this.fileImport = null
      this.tableError = false
      this.disableImport = false
      this.isImport = false
      this.title = "Import chỉ số team lead"
    },
  }
}
</script>

<style scoped>

</style>